import { tokens } from "@blurb/codex-react";
import { Box } from "@mantine/core";
import React from "react";

interface ErrorStateLayoutProps {
  /** Is root page. */
  root?: boolean;
  "data-testid"?: string;
  children: React.ReactNode;
}

/**
 * Shared full-page/full-panel layout for route error states (crash screen, 404).
 * Keeps the icon badge, heading, body, and action button centered and consistently spaced.
 */
export const ErrorStateLayout: React.FC<ErrorStateLayoutProps> = ({ root = true, children, ...rest }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      gap: tokens.spacing[6],
      width: "100%",
      height: root ? "100vh" : "100%",
      paddingInline: tokens.spacing[20],
      paddingBottom: "7.5rem",
      backgroundColor: tokens.color.primitive.light.calm[50],
      color: tokens.color.semantic.text.bold,
    }}
    {...rest}
  >
    {children}
  </Box>
);
